import { render } from "./TableComponentNew.vue?vue&type=template&id=e4e2933e"
import script from "./TableComponentNew.vue?vue&type=script&lang=js"
export * from "./TableComponentNew.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__